import client from 'providers/fetchClient'

export const userSignUp = data => client.post('/partners/signup', data)

export const editUserInfo = (id, data) => client.patch(`/partners/${id}`, data)

export const updatePassword = (id, data) => client.put(`/users/${id}/password`, data)

export const setRenewPackageDate = (id, data) => client.patch(`/partners/${id}`, data)

export const checkDocument = document => client.post('/partners/check-document', document)

export const getTermsOfUse = () => client.get('/partner-contracts/last')

export const getPreRegistrations = async ({ sortBy, pagination, ...filters }) => {
  const params = { ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get('/partners/pre-registrations', { params })

  return {
    preRegistrations: data.data,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const approvePreRegistration = id => client.post(`/partners/${id}/approve`)

export const rejectPreRegistration = id => client.post(`/partners/${id}/reject`)

export const getPartners = async ({ search, pagination, sortBy, ...filters }) => {
  const params = { search, ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get('/partners', { params })

  return {
    partners: data.data,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const getPartner = id => client.get(`/partners/${id}`)

export const addPackageSpecialPrice = (id, data) => client.post(`/partners/${id}/prices`, data)

export const deactivatePartner = id => client.post(`/partners/${id}/deactivate`)

export const activatePartner = id => client.post(`partners/${id}/activate`)

export const addDiscount = (id, data) => client.post(`/partners/${id}/discount`, data)

export const getAPIKey = () => client.get('/partners/api-key').then(response => response.data)

export const createNewAPIKey = () => client.post('/partners/api-key').then(response => response.data)
